module.exports = __webpack_public_path__ + "static/media/music1.356ffdd5.mp3";